import { render } from "./CartItemRemove.vue?vue&type=template&id=1627e6c8&ts=true"
import script from "./CartItemRemove.vue?vue&type=script&lang=ts"
export * from "./CartItemRemove.vue?vue&type=script&lang=ts"

import "./CartItemRemove.vue?vue&type=style&index=0&id=1627e6c8&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__